<div class="report-adjustments-sidenav" fxLayout="column" fxFlex>
    <div
        class="report-adjustments-sidenav__header"
        fxLayout="row"
        fxLayoutAlign="start center"
    >
        @if (currentPage && currentPage?.page !== 4) {
            <i
                class="fa-solid fa-angle-left cursor-pointer"
                (click)="onBackHome()"
            ></i>
        } @else if (currentPage?.page === 4) {
            <i
                class="fa-solid fa-xmark cursor-pointer"
                (click)="onCloseSidenav()"
            ></i>
        } @else {
            <i [class]="currentPage?.icon || 'fa-solid fa-sliders'"></i>
        }

        <h1>{{ currentPage?.label || "Ajustes" }}</h1>
    </div>
    <div fxLayout="column" fxFlex>
        @switch (currentPage?.page) {
            @case (0) {
                <app-report-adjustments-period
                    [company]="company"
                    [scenarios]="scenarios"
                    [options]="report.options"
                    [dropdownConfigs]="dropdownConfigs?.period"
                    (handleChangePeriod)="onChangePeriod($event)"
                ></app-report-adjustments-period>
            }
            @case (1) {
                <app-report-adjustments-comparation
                    [report]="report"
                    [company]="company"
                    [scenarios]="scenarios"
                    [options]="report.options"
                    [dropdownConfigs]="dropdownConfigs?.comparation"
                    (handleChangeComparation)="onChangeComparation($event)"
                    (handleResetPeriod)="handleResetPeriod.emit()"
                ></app-report-adjustments-comparation>
            }
            @case (2) {
                <app-report-adjustments-analisysplus
                    [options]="report.options"
                    [budgets]="report.budgets"
                    [projections]="report.projections"
                    (handleChangeAnalysis)="onApplyAnalysis($event)"
                    (handleResetAnalysis)="handleResetAnalysis.emit()"
                ></app-report-adjustments-analisysplus>
            }
            @case (3) {
                <app-report-adjustments-without-analisysplus
                    [company]="company"
                    [report]="report"
                ></app-report-adjustments-without-analisysplus>
            }
            @default {
                <app-report-adjustments-navigation
                    [company]="company"
                    [options]="report.options"
                    [optionsNavigation]="optionsNavigation"
                    (onNavigateChange)="onNavigateChange($event)"
                    style="height: 100%"
                ></app-report-adjustments-navigation>
            }
        }
    </div>
</div>
